import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import './tasks.css';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useAlertContext } from 'src/hooks/use-alert';
import { getAllTasks, deleteTask, createTask, UpdateTask } from "src/apis/task_apis";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setHours } from 'date-fns';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { defer } from "react-router-dom";



const Tasks = () => {
  const alert = useAlertContext();
  const [date, setDate] = useState(new Date());
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [sortOption, setSortOption] = useState("date");
  const [expiredDate, setExpiredDate] = useState();
  const [endRepetition, setEndRepetition] = useState();
  const [endRepetitionDisabled, setEndRepetitionDisabled] = useState(true);

  const [tasks, setTasks] = useState([]);

  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [newTaskText, setNewTaskText] = useState('');
  const [newTaskTipology, setNewTaskTipology] = useState('');
  const [newTaskStatus, setNewTaskStatus] = useState('');
  const [newTaskRepitition, setNewTaskRepitition] = useState('');
  const [newTaskPriority, setNewTaskPriority] = useState('');
  const [newTaskDetails, setNewTaskDetails] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeDate, setActiveDate] = useState(null);
  const [postponeDate, setPostponeDate] = useState(null);
  const [isEditing, setIsEditing] = useState(false);


  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePostponeClick = () => {
    setIsEditing(true);
    setPostponeDate(selectedTask.expired_date);
  };


  const handleSaveClick = async () => {
    try {
      // Adjust the date to your local timezone
      const localPostponeDate = new Date(
        postponeDate.getTime() - postponeDate.getTimezoneOffset() * 60000
      );

      // Make an API call to update the task's expired date
      const updatedTask = { ...selectedTask, expired_date: localPostponeDate };
      const response = await UpdateTask(updatedTask);

      if (response && response.errors) {
        alert.setError((prev) => [...prev,{ status: true, message: response.errors }]);
      } else {
        // Remove the task from the old date in selectedTasks
        setSelectedTasks((prevSelectedTasks) =>
          prevSelectedTasks.filter((task) => task.id !== updatedTask.id)
        );

        // Update the tasks state with the updated task
        setTasks((prevTasks) =>
          prevTasks.map((task) =>
            task.id === updatedTask.id ? updatedTask : task
          )
        );

        // Add the task to the new date in selectedTasks
        setSelectedTasks((prevSelectedTasks) => [...prevSelectedTasks, updatedTask]);

        // Close the dialog and refresh the tasks
        setIsEditing(false);
        setDialogOpen(false);
        refreshTasks();

        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: "Task updated succesfully",
          index:prev.length
        }]);
      }
    } catch (error) {
      console.error(error);
    }
  };



  const today = setHours(new Date(), 0);

  const handleDateClick = (value) => {
    const year = value.getUTCFullYear();
    const month = value.getUTCMonth();
    const day = (value.getUTCDate()) + 1;
    const date = new Date(Date.UTC(year, month, day));
    const dateStr = date.toISOString().substring(0, 10);
    console.log(date);
    const tasksForDate = tasks.filter(task => task.date === dateStr);
    setSelectedTasks(tasksForDate);
    setDate(date);
    setSelectedDate(dateStr);
  };

  const handleNewTaskTextChange = (event) => {
    setNewTaskText(event.target.value);
  };

  const handleNewTaskDetailsChange = (event) => {
    setNewTaskDetails(event.target.value);
  };

  const handleNewTaskTipologyChange = (event) => {
    setNewTaskTipology(event.target.value);
  };

  const handleNewTaskPriorityChange = (event) => {
    setNewTaskPriority(event.target.value);
  };

  const handleNewTaskRepititionChange = (event) => {
    const value = event.target.value;
    setNewTaskRepitition(value);

    // Check if the selected value is "nothing"
    if (value === "nothing" || value === "") {
      setEndRepetitionDisabled(true);
      setEndRepetition(null); // Clear the end_repetition date
    } else {
      setEndRepetitionDisabled(false);
    }
  };



  const handleClodeAddNew = () => {
    setDialogVisible(false);
    setNewTaskText('');
    setNewTaskTipology('');
    setNewTaskPriority('');
    setNewTaskRepitition('');
    setNewTaskStatus('');
    setNewTaskDetails('');
    setExpiredDate('');
    setEndRepetition('');
  }


  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High':
        return '#E16162';
      case 'Medium':
        return '#e3f829ce';
      case 'Low':
        return '#2cad66';
      default:
        return 'transparent'; // Default to transparent if priority is not recognized
    }
  };


  const handleNewTaskStatusChange = (event) => {
    setNewTaskStatus(event.target.value);
  };

  const sortTasks = (tasksToSort, sortBy) => {
    if (sortBy === "name") {
      return tasksToSort.slice().sort((a, b) => a.text.localeCompare(b.text));
    } else if (sortBy === "priority") {
      return tasksToSort.slice().sort((a, b) => {
        const priorityOrder = {
          High: 3,
          Medium: 2,
          Low: 1,
        };

        const priorityA = priorityOrder[a.priority] || 0;
        const priorityB = priorityOrder[b.priority] || 0;

        // Compare by priority
        if (priorityA > priorityB) return -1;
        if (priorityA < priorityB) return 1;

        // If priorities are equal, compare by name
        return a.text.localeCompare(b.text);
      });
    }

    // Default to returning the original array
    return tasksToSort;
  };

  const handleSortChange = (sortBy) => {
    const sortedTasks = sortTasks(selectedTasks, sortBy);
    setSelectedTasks(sortedTasks);
    setSortOption(sortBy);
  };


  async function DeleteTask(id) {
    const response = await deleteTask(id);
    return response;
  }



  const refreshTasks = async () => {
    try {
      const allTasks = await getAllTasks();

      if (allTasks) {
        const formattedTasks = allTasks.map((task) => ({
          id: task.id,
          date: task.expired_date.substring(0, 10),
          time: task.expired_date.substring(11, 16), // Extract the time portion
          text: task.title,
          details: task.description,
          priority: task.priority,
          tipologia: task.tipologia,
          repetition: task.repetition,
          end_repetition: task.end_repetition,
        }));

        setTasks(formattedTasks);
      }
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    refreshTasks();
  }, []);

  const calculateRecurringDates = (startDate, repetition, endRepetition) => {
    const recurringDates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endRepetition) {
      recurringDates.push(new Date(currentDate));
      switch (repetition) {
        case 'nothing':
          currentDate.setUTCMonth(currentDate);
          break;
        case 'Monthly':
          currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
          break;
        case '3 Month':
          currentDate.setUTCMonth(currentDate.getUTCMonth() + 3);
          break;
        case '6 Month':
          currentDate.setUTCMonth(currentDate.getUTCMonth() + 6);
          break;
        case 'Yearly':
          currentDate.setUTCFullYear(currentDate.getUTCFullYear() + 1);
          break;
        case '3 Years':
          currentDate.setUTCFullYear(currentDate.getUTCFullYear() + 3);
          break;
        default:
          break;
      }
    }

    return recurringDates;
  };


  const handleAddTask = async (event) => {
    event.preventDefault();

    // Check if required fields are empty
    if (!expiredDate || !newTaskText || !newTaskPriority) {
      alert.setError((prev) => [...prev,
      {  status: true,
        message: 'Expired Date, Title, and Priority are obligatory fields.',index:prev.length
      }]);
      return;
    }

    // Adjust the date to your local timezone
    const localExpiredDate = new Date(
      expiredDate.getTime() - expiredDate.getTimezoneOffset() * 60000
    );

    // Calculate recurring dates only if newTaskRepitition is not empty
    let recurringDates = [];
    if (newTaskRepitition) {
      if (endRepetition) {
        const localEndRepetitionDate = new Date(
          endRepetition.getTime() - endRepetition.getTimezoneOffset() * 60000
        );
        if (localEndRepetitionDate < localExpiredDate) {
          // Handle validation error
          alert.setError((prev) => [...prev,{
            status: true,
            message: 'End Repetition date cannot be earlier than Expire Date.',
          }]);
          return;
        }
        recurringDates = calculateRecurringDates(
          localExpiredDate,
          newTaskRepitition,
          localEndRepetitionDate
        );
      } else {
        // Handle validation error when endRepetition is not set
        alert.setError((prev) => [...prev,{
          status: true,
          message: 'Please select an End Repetition date.',
        }]);
        return;
      }
    }

    // Create a new task for each recurring date or a single task if no repetition is set
    const newTasks = newTaskRepitition
      ? recurringDates.map((date) => ({
        description: newTaskDetails,
        end_repetition: date.toISOString().substring(0, 10),
        expired_date: date.toISOString().substring(0, 10),
        priority: newTaskPriority,
        repetition: newTaskRepitition,
        status: newTaskStatus,
        tipologia: newTaskTipology,
        title: newTaskText,
      }))
      : [
        {
          description: newTaskDetails,
          expired_date: localExpiredDate.toISOString().substring(0, 10),
          priority: newTaskPriority,
          repetition: newTaskRepitition,
          status: newTaskStatus,
          tipologia: newTaskTipology,
          title: newTaskText,
        },
      ];

    try {
      // Create tasks on the server
      const responses = await Promise.all(
        newTasks.map((newTask) => createTask(newTask))
      );

      // Check for success and handle responses
      responses.forEach((response, index) => {
        if (response.success) {
          // Add the new task to the tasks state
          setTasks([...tasks, newTasks[index]]);
        } else if (response.errors) {
          // Handle errors for individual tasks
        } else {
          console.error('Invalid response from createTask:', response);
        }
      });

      // Reset form fields and close the dialog
      setNewTaskText('');
      setNewTaskTipology('');
      setNewTaskPriority('');
      setNewTaskRepitition('');
      setNewTaskStatus('');
      setNewTaskDetails('');
      setExpiredDate('');
      setEndRepetition('');
      setDialogVisible(false);

      alert.setSuccess( (prev) => [...prev,
      {  status: true,
        message: 'Tasks added successfully!',index:prev.length
      }]);
      refreshTasks();
    } catch (error) {
      console.error('Error in handleAddTask:', error);
    }
  };




  const tileContent = ({ date }) => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = (date.getUTCDate()) + 1;
    const date2 = new Date(Date.UTC(year, month, day));
    const dateStr = (date2).toISOString().substring(0, 10);
    const tasksForDate = tasks.filter(task => task.date === dateStr);

    if (tasksForDate.length > 0) {
      return <div className="task-dot selected-date"><AssignmentIcon /></div>;
    } else {
      return null;
    }
  };


  const deleteTaskFromComponent = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this task?');

    if (confirmDelete) {
      console.log(id);
      try {
        // Delete the task on the server
        const response = await DeleteTask(id);

        if (response.success) {
          // Remove the deleted task from the tasks state
          setTasks(tasks.filter(task => task.id !== id));

          // Remove the deleted task from the selectedTasks state if it's in the selected date
          setSelectedTasks(selectedTasks.filter(task => task.id !== id));

          alert.setSuccess((prev) => [...prev,{
            status: true,
            message: "Tasks deleted succesfully",
            index:prev.length
          }]);
        } else {
          alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };





  const filteredTasks = selectedTasks.filter(task => task.text.toLowerCase().includes(searchQuery.toLowerCase()));

  const handleViewTask = (task) => {
    setSelectedTask(task);
    setDialogOpen(true);
  };

  return (
    <div className="Tasks">
      <div className='started'><h2>Tasks</h2></div>
      <div className="taskk">
        <div className="content">
          <div className="App">
            <div className="calendar-and-tasks">
              <Grid container>
                <Grid item md={6} xs={12}>

                  <div className="calendar">
                    <div className="add-task-form">
                      <ButtonPolicy onClick={() => setDialogVisible(true)}>Add New Task</ButtonPolicy>
                    </div>
                    <Calendar
                      value={date}
                      onClickDay={(value) => {
                        setActiveDate(value);
                        handleDateClick(value);
                      }}
                      tileContent={tileContent}
                      tileClassName={({ date }) => {
                        if (activeDate && date.toDateString() === activeDate.toDateString()) {
                          return 'active-date';
                        }
                        return null;
                      }}
                    />
                  </div>
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                  <Grid container>
                    <Grid item md={8} xs={12} lg={8} sm={8}>
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        placeholder="Search tasks"
                      />
                    </Grid>
                    <Grid item md={4} lg={4} sm={4} xs={12}>
                      <div className="tasksortBy">
                        <FormControl>
                          <InputLabel>Sort By</InputLabel>
                          <Select
                            value={sortOption}
                            onChange={(e) => handleSortChange(e.target.value)}
                          >
                            <MenuItem value="name">Name</MenuItem>
                            <MenuItem value="priority">Priority</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </Grid>
                    <Grid item md={12} xs={12} lg={12} sm={12}>
                      <div className="tasks">
                        <Grid container>
                          {filteredTasks.length > 0 ? (
                            filteredTasks.map((task) => (
                              <Grid item lg={6} md={6} sm={6} xs={12} xl={4} key={task.id}>
                                <div className='hold'>
                                  <div className='taskCard'>
                                    <div className='taskCardTitle'>
                                      {task.text}
                                    </div>
                                    <ul>
                                      <>
                                        <li>
                                          <div className='taskCardDetails'>
                                            {task.details}
                                          </div>
                                        </li>
                                        <li>
                                          <div className='taskCardTag'>
                                            <span style={{ backgroundColor: getPriorityColor(task.priority) }}>
                                              {task.priority}
                                            </span>
                                          </div>
                                        </li>
                                        <li>
                                          <span className='date'>{task.date}</span>
                                        </li>
                                      </>
                                    </ul>
                                    <div className='taskButtonContainer'>
                                      <ButtonPolicy onClick={() => handleViewTask(task)} className='viewTask'>Expand</ButtonPolicy>
                                      <ButtonPolicy onClick={() => deleteTaskFromComponent(task.id)} className='muteButton'>Delete</ButtonPolicy>
                                    </div>
                                    <div className='taskCardDelete'>
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            ))
                          ) : (
                            <p>No tasks for selected date</p>
                          )}
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle><AssignmentIcon /> Task Details</DialogTitle>
        <DialogContent>
          {selectedTask && (
            <div>
              <p><CalendarMonthIcon /> Expire Date: {selectedTask.date}</p>
              <p>Title: {selectedTask.text}</p>
              <p>Details: {selectedTask.details}</p>
              <p>Typology: {selectedTask.tipologia}</p>
              <p>Priority: {selectedTask.priority}</p>
              <p>Repitition: {selectedTask.repetition}</p>
              <p>End Repitition: {selectedTask.end_repetition}</p>
              {isEditing ? (
                <>
                  <DatePicker
                    selected={postponeDate}
                    onChange={(date) => setPostponeDate(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select a new Expire Date"
                    minDate={today}
                  />
                  <div className='myButtonWrapper'>
                    <div className='closeDetailsButton'><ButtonPolicy onClick={() => setDialogOpen(false)}>Close</ButtonPolicy></div>
                    <div className='PostponeButton'><ButtonPolicy onClick={handleSaveClick}>Save</ButtonPolicy></div>
                  </div>
                </>
              ) : (
                <div className='myButtonWrapper'>
                  <div className='closeDetailsButton'><ButtonPolicy onClick={() => setDialogOpen(false)}>Close</ButtonPolicy></div>
                  <div className='PostponeButton'><ButtonPolicy onClick={handlePostponeClick}>Postpone</ButtonPolicy></div>

                </div>
              )}
            </div>
          )}

        </DialogContent>
        <DialogActions>

        </DialogActions>
      </Dialog>

      <Dialog open={dialogVisible} onClose={() => setDialogVisible(false)}>
        <DialogTitle>Add New Task</DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddTask}>
            <div className='addTaskTitle'>
              <DatePicker
                selected={expiredDate}
                onChange={(date) => setExpiredDate(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText="Expire Date"
                minDate={today}
              />
            </div>
            <div className='addTaskTitle'><input placeholder='Title' id='titleNewTask' type="text" value={newTaskText} onChange={handleNewTaskTextChange} /></div>
            <div className='addTaskTitle'>
              <select
                value={newTaskTipology}
                onChange={handleNewTaskTipologyChange}
              >
                <option value="" disabled selected>Tipology</option>
                <option value="Maintenance Service">Maintenance Service</option>
                <option value="Economical Proposal">Economical Proposal</option>
              </select>
            </div>
            <div className='addTaskTitle'>
              <select
                value={newTaskPriority}
                onChange={handleNewTaskPriorityChange}
              >
                <option value="" disabled selected>Priority</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div className='addTaskTitle'>
              <select
                value={newTaskRepitition}
                onChange={handleNewTaskRepititionChange}
              >
                <option value="nothing">Repetition</option>
                <option value="Monthly">Monthly</option>
                <option value="3 Month">3 Months</option>
                <option value="6 Month">6 Months</option>
                <option value="Yearly">Yearly</option>
                <option value="3 Years">3 years</option>
              </select>
            </div>

            <div className='addTaskTitle'>
              <DatePicker
                selected={endRepetition}
                onChange={(date) => setEndRepetition(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText="End Repitition"
                minDate={today}
                disabled={endRepetitionDisabled}
              />
            </div>
            <div className='addTaskTitle'>
              <select
                value={newTaskStatus}
                onChange={handleNewTaskStatusChange}
              >
                <option value="" disabled selected>Status</option>
                <option value="Open">Open</option>
                <option value="Activated">Activated</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
            <div className='addTaskDetail'><textarea placeholder='Details' id='detailsNewTask' type="text" cols="40" rows="5" multilin='true' value={newTaskDetails} onChange={handleNewTaskDetailsChange} /></div>

          </form>
        </DialogContent>
        <DialogActions>
          <ButtonPolicy className='cancelButton' onClick={handleClodeAddNew}>Cancel</ButtonPolicy>
          <ButtonPolicy className='addTaskButton' type="submit" onClick={handleAddTask}>Add</ButtonPolicy>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Tasks;

async function loadTasks() {
  const response = await getAllTasks();

  return response;
}
export async function loader({request, params}) {
  return defer({
    tasks: await loadTasks(),
  });
}


